import React from "react";
import "./detailpage.scss";

export class DetailPageContent extends React.PureComponent {
  render() {
    return <div className="detail-page-content">{this.props.children}</div>;
  }
}
